export default {
    namespaced: true,
    state: {
        // 菜单列表
        msgList: [],
        msgItem: {},
        endLive: {}, // 直播结束消息
        beBanned: {}, // 主播被封禁
        maskSwitch: {}, // 禁画面开关
        videoPause: 0,
        videoPlay: 0,
    },
    // getters:{},
    mutations: {
        setMsgList(state: { msgList: any; }, obj: any) {
            const arr = state.msgList
            arr.push(obj)
            state.msgList = []
            state.msgList = arr
            // state.msgList.push(obj)
        },
        setClearMsgList(state: { msgList: any; }, obj: any) {
            state.msgList = []
        },
        setMsgItem(state: { msgItem: any; }, obj: any) {
            state.msgItem = {}
            state.msgItem = obj
        },
        setEndLive(state: { endLive: any; }, obj: any) {
            state.endLive = obj
        },
        setBeBanned(state: { beBanned: any; }, obj: any) {
            state.beBanned = obj
        },
        setMaskSwitch(state: { maskSwitch: any; }, obj: any) {
            state.maskSwitch = obj
        },
        setVideoPause(state: { videoPause: any; }, obj: any) {
            state.videoPause++
        },
        setVideoPlay(state: { videoPlay: any; }, obj: any) {
            state.videoPlay++
        },
    },
    actions: {
        updateMsgList({
            commit,
            // tslint:disable-next-line:align
        }, info) {
            commit('setMsgList', info)
        },
        clearMsgList({
            commit,
            // tslint:disable-next-line:align
        }, info) {
            commit('setClearMsgList', info)
        },
        updateMsgItem({
            commit,
            // tslint:disable-next-line:align
        }, info) {
            commit('setMsgItem', info)
        },
        // 更新直播结束
        updateEndLive({
            commit,
            // tslint:disable-next-line:align
        }, info) {
            commit('setEndLive', info)
        },
        // 更新主播被封禁
        updateBeBanned({
            commit,
            // tslint:disable-next-line:align
        }, info) {
            commit('setBeBanned', info)
        },
        // 更新禁画面开关
        updateMaskSwitch({
            commit,
            // tslint:disable-next-line:align
        }, info) {
            commit('setMaskSwitch', info)
        },
        // 更新是否暂停直播
        updateVideoPause({
            commit,
            // tslint:disable-next-line:align
        }) {
            commit('setVideoPause')
        },
        // 更新是否播放直播
        updateVideoPlay({
            commit,
            // tslint:disable-next-line:align
        }) {
            commit('setVideoPlay')
        },
    },
}
